import { useEffect, useRef } from 'react';
import type { LineaTranscripcion } from './sesionMachine';

/**
 * Transcripción de la entrevista (D-14): lo que transcribió el STT del
 * estudiante (`alumno_transcripcion`) y lo que dijo el paciente
 * (`patient_response`, sin marcas de actuación). Se desplaza sola al
 * último turno.
 */
export function PanelTranscripcion({ lineas }: { lineas: LineaTranscripcion[] }) {
  const finRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    finRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
  }, [lineas.length]);

  return (
    <section
      aria-label="Transcripción"
      className="flex min-h-0 flex-1 flex-col rounded-2xl bg-white shadow-sm"
    >
      <h2 className="border-b border-slate-100 px-4 py-3 text-sm font-semibold text-slate-700">
        Transcripción
      </h2>
      {lineas.length === 0 ? (
        <p className="px-4 py-6 text-sm text-slate-400">
          La conversación va a aparecer aquí a medida que avance la entrevista.
        </p>
      ) : (
        <ol className="min-h-0 flex-1 space-y-3 overflow-y-auto px-4 py-3 text-sm">
          {lineas.map((l, i) => (
            <li key={i} className={l.rol === 'alumno' ? 'text-right' : ''}>
              <span className="block text-xs font-medium text-slate-400">
                {l.rol === 'alumno' ? 'Estudiante' : 'Paciente'}
              </span>
              <span
                className={`inline-block max-w-[90%] rounded-2xl px-3 py-2 text-left ${
                  l.rol === 'alumno'
                    ? 'bg-primary-50 text-slate-800'
                    : 'bg-slate-100 text-slate-800'
                }`}
              >
                {l.texto}
              </span>
            </li>
          ))}
          <li ref={finRef} aria-hidden="true" />
        </ol>
      )}
    </section>
  );
}
